/** Display precision only; domain scores and comparisons retain their full values. */
export function scoreNumber(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "—";
  return new Intl.NumberFormat("en-GB", {
    maximumFractionDigits: 2,
    useGrouping: false,
  }).format(Object.is(value, -0) || Math.abs(value) < 0.005 ? 0 : value);
}
